// @flow
export { default } from './Comment';
